module.exports = "import React from 'react';\nimport Slider from 'material-ui/Slider';\n\n/**\n * By default, the slider is continuous.\n * The `step` property causes the slider to move in discrete increments.\n */\nconst SliderExampleStep = () => (\n  <Slider step={0.10} value={0.5} />\n);\n\nexport default SliderExampleStep;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/Slider/ExampleStep.js
 ** module id = 1050
 ** module chunks = 0
 **/